module.exports = __webpack_public_path__ + "img/logo.9ee35d8d.png";